import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  Row,
  Spin,
  notification,
  Form,
  DatePicker,
  message
} from "antd";
import { saveAs } from "file-saver";
import util from "helpers/util";

import apiStockAdjustment from "constants/api/stockAdjustment";

export default function DownloadAll() {
  const dateFormat = "YYYY-MM-DD";
  const { RangePicker } = DatePicker;

  const [formDownloadAll] = Form.useForm();

  const [downloadLoading, setDownloadLoading] = useState(false);

  const [dates, setDates] = useState(null);
  const [value, setValue] = useState(null);
  const [limitDays, setLimitDays] = useState(0);

  useEffect(() => {
    apiStockAdjustment.getLimitFetchDays()
      .then((res) => {
        if (res.success) {
          setLimitDays(res.result);
        }
        else {
          message.error("Cannot get limit days");
        }
      })
      .catch((err) => {
        message.error("Cannot get limit days");
      })
  });

  const disabledDate = (current) => {
    if (!dates) {
      return false;
    }
    const tooLate = dates[0] && current.diff(dates[0], 'days') >= limitDays;
    const tooEarly = dates[1] && dates[1].diff(current, 'days') >= limitDays;
    return !!tooEarly || !!tooLate;
  };

  const onOpenChange = (open) => {
    if (open) {
      setDates([null, null]);
    } else {
      setDates(null);
    }
  };

  const onFinishFormDownloadAll = (values) => {
    setDownloadLoading(true);

    const dataToSubmit = {
      startTime: values.creationTime == null || values.creationTime[0] == null
        ? ""
        : values.creationTime[0].format(dateFormat),
      endTime: values.creationTime == null || values.creationTime[1] == null
        ? ""
        : values.creationTime[1].format(dateFormat),
    };
    // if (dataToSubmit.startTime == "" || dataToSubmit.endTime == "") {
    //   notification.error({
    //     message: "Error",
    //     description: "Creation time cannot be empty",
    //     duration: 0,
    //   });

    //   setDownloadLoading(false);

    //   return;
    // }

    //calculate difference days, with today (+ 1)
    if (dataToSubmit.startTime != '') {
      const dateDiff = values.creationTime[1].diff(values.creationTime[0], 'days') + 1;

      if (dateDiff > limitDays) {
        notification.error({
          message: "Error",
          description: `Creation date range must ${limitDays} days`,
          duration: 0,
        });

        setDownloadLoading(false);

        return;
      }
    }

    apiStockAdjustment
      .downloadAllStockAdjustment(dataToSubmit.startTime, dataToSubmit.endTime)
      .then((res) => {
        var blob = new Blob([res.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
        });
        let url = window.URL.createObjectURL(blob);
        saveAs(url, "stock_adjustment.xlsx");
        setDownloadLoading(false);
      })
      .catch((err) => {
        util.displayApiError(err);
        setDownloadLoading(false);
      });
  };

  const onFinishFailedFormAdjustStatus = (errorInfo) => {
    notification.error({
      message: "Error",
      description: "Failed to get data",
      duration: 0,
    });
  };

  return (
    <>
      <Spin size="large" tip="Loading..." spinning={downloadLoading}>
        <Row justify="center">
          <Col
            span={24}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Form
              layout="vertical"
              form={formDownloadAll}
              onFinish={onFinishFormDownloadAll}
              initialValues={{
                creationDate: null
              }}
              onFinishFailed={onFinishFailedFormAdjustStatus}
            >
              <Form.Item label="Creation Date" name="creationTime">
                <RangePicker
                  style={{ width: "100%" }}
                  value={dates || value}
                  disabledDate={disabledDate}
                  onCalendarChange={(val) => {
                    setDates(val);
                  }}
                  onChange={(val) => {
                    setValue(val);
                  }}
                  onOpenChange={onOpenChange}
                  changeOnBlur
                />
              </Form.Item>

              <Button
                block
                type="primary"
                htmlType="submit"
                style={{ width: "100%" }}
              >
                Download all adjustment
              </Button>
            </Form>
            <br />
          </Col>
        </Row>
      </Spin>
    </>
  );
}
